module.exports = __webpack_public_path__ + "media/site/images/icons/livedata-yellow-icon-bf6fce86728beeb6fd8f1ba22996e197.svg";